import React, { useState, useEffect } from "react";
import { LayoutGrid, Table } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import api from "../api/api";

export default function OrderFormExplorer() {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("lastVisited");
    navigate("/");
  };
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [viewMode, setViewMode] = useState("table"); // table or card


  const exportToCSV = () => {
    if (filteredOrders.length === 0) {
      alert("No data to export.");
      return;
    }

    // Define CSV headers
    const headers = [
      "Vcode",
      "Party",
      "Address",
      "Area",
      "Route1",
      "Route2",
      "Start Date",
      "Nextdays",
      "Mobile",
      "Phone",
      "Paymode",
      "TransNo",
      "PrePaidAmt"
    ];

    // Map data to CSV rows
    const csvRows = filteredOrders.map(order => [
      order.vcode || "",
      order.vname || "",
      order.address || "",
      order.area || "",
      order.route1 || "",
      order.route2 || "",
      order.startDate || "",
      order.nextdays || "",
      order.mobile || "",
      order.phone || "",
      order.paymode || "",
      order.transNo || "",
      order.prePaidAmt || ""
    ]);

    // Combine headers and rows
    const csvContent = [headers, ...csvRows]
      .map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(","))
      .join("\n");

    // Create and download the file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `orders_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const fetchOrders = async () => {
    try {
      setLoading(true);
      const User = sessionStorage.getItem("username");
      if (!User) {
        alert("Session expired. Please log in again.");
        navigate("/");
        return;
      }

      const res = await api.get("GetOrderFormExplrAPI", { User });
      const rows = res?.data?.GetOrderFormExplrAPIjs?.Table || res?.GetOrderFormExplrAPIjs?.Table || [];
      const formatted = rows.map((row, index) => ({
        id: index + 1,
        orId: row.OrId,
        vid: row.Vid,
        vcode: row.Vcode,
        vname: row.Vname,
        address: row.Address1,
        mobile: row.Mobile,
        phone: row.Phone,
        area: row.Area,
        route1: row.Route1,
        route2: row.Route2,
        startDate: row.StartDate?.split("T")[0],
        nextdays: row.Nextdays,
        username: row.Username,
        entryTime: row.EntryTime,
        areaId: row.AreaId,
        deliveryNote: row.DeliveryNote || "",
        paymentRemark: row.PaymentRemark || "",
        paymode: row.Paymode,
        transNo: row.TransNo,
        prePaidAmt: row.PrePaidAmt,
      }));
      setOrders(formatted);
      setFilteredOrders(formatted);
    } catch (error) {
      console.error(error);
      alert("Failed to load orders.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
    const interval = setInterval(() => {
      fetchOrders();
    }, 120000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleKeyShortcuts = (e) => {
      if (e.key === "F5") {
        e.preventDefault();          // Stop browser refresh
        navigate("/orderform");      // Open new order page
      }
    };
  
    window.addEventListener("keydown", handleKeyShortcuts);
  
    return () => window.removeEventListener("keydown", handleKeyShortcuts);
  }, [navigate]);

  useEffect(() => {
    if (!searchText) {
      setFilteredOrders(orders);
    } else {
      const lowerSearch = searchText.toLowerCase();
      const filtered = orders.filter(
        (o) =>
          o.vname?.toLowerCase().includes(lowerSearch) ||
          o.mobile?.toLowerCase().includes(lowerSearch) ||
          String(o.orId).includes(lowerSearch) ||
          o.area?.toLowerCase().includes(lowerSearch)
      );
      setFilteredOrders(filtered);
    }
  }, [searchText, orders]);

  if (loading)
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="text-center">
          <div className="w-10 h-10 mx-auto mb-4 border-t-4 border-orange-500 rounded-full animate-spin"></div>
          <p className="text-lg text-gray-600">Loading orders...</p>
        </div>
      </div>
    );

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onLogout={handleLogout} />
      <main className="p-6 md:ml-64">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 gap-4">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/dashboard')}
              className="inline-flex items-center gap-1 px-3 py-1 text-gray-800 font-semibold
                 bg-gray-200 hover:bg-gray-300 rounded-full shadow transition
                 text-sm sm:text-base w-auto self-start"
            >
              ← Back
            </button>
            <h2 className="text-2xl font-semibold text-orange-600 ">Order Explorer</h2>
          </div>
          
        </div>
<div  className="flex items-center gap-2 mb-2">
            <button
  onClick={() => navigate("/orderform")}
  className="
    px-2.5 py-1.5
    text-sm font-semibold
    bg-orange-500 text-white
    rounded-full
    hover:bg-orange-600
    transition
    whitespace-nowrap
  "
>
  + New Order
</button>
           
 
        
          <input
            type="text"
            placeholder="🔍 Search by Name, Mobile, Order ID, Area"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="ml-auto mr-4 px-3 py-2 w-full md:w-72 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400"
          />
          <button
  onClick={() => setViewMode(viewMode === "table" ? "card" : "table")}
  className="flex items-center gap-2 px-2 py-2 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition shadow"
>
  {viewMode === "table" ? (
    <>
      <LayoutGrid size={18} />
      Card
    </>
  ) : (
    <>
      <Table size={18} />
      Table
    </>
  )}
</button>
  {viewMode === "table" && (
    <button
  onClick={exportToCSV}
  className="
    px-2.5 py-1.5
    text-sm font-semibold
    inline-flex items-center
    bg-blue-500 text-white
    rounded-full
    hover:bg-blue-700
    shadow
    transition
    whitespace-nowrap
  "
>
  📄 Export
</button>
  )}
        </div>

        {viewMode === "table" ? (
          <div className="relative -mx-6 sm:-mx-0">
            <div className="overflow-x-auto">
              <table className="min-w-[100px] w-full">
                <thead className="bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition shadow">
                  <tr>
                    <th className="p-1 text-left font-medium text-white">Vcode</th>
                    <th className="p-1 text-left font-medium text-white">Party</th>
                    <th className="p-1 text-left font-medium text-white">Address</th>
                    <th className="p-1 text-left font-medium text-white">Area</th>
                    <th className="p-1 text-left font-medium text-white">Route1</th>
                    <th className="p-1 text-left font-medium text-white">Start Date</th>
                    <th className="p-1 text-left font-medium text-white">Nextdays</th>
                    <th className="p-1 text-left font-medium text-white">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOrders.map((order) => (
                    <tr key={order.id} className="border-b border-gray-200 hover:bg-gray-50">
                      <td className="p-1 font-medium">{order.vcode}</td>
                      <td className="p-1">{order.vname}</td>
                      <td className="p-1">{order.address}</td>
                      <td className="p-1">{order.area}</td>
                      <td className="p-1">{order.route1}</td>
                      <td className="p-1 whitespace-nowrap">{order.startDate}</td>
                      <td className="p-1 text-right">{order.nextdays}</td>
                      <td className="p-1">
                        <button
                          onClick={async () => {
                            try {
                              const response = await api.EditFdOrderlistAPI(order.orId);
                              const editData = response?.EditFdOrderlistAPIjs;
                              navigate('/orderform', { state: { editData } });
                            } catch (error) {
                              console.error('Error fetching edit data:', error);
                              alert('Failed to load edit data.');
                            }
                          }}
                          className="px-3 py-1 bg-blue-500 text-white text-sm font-semibold rounded hover:bg-blue-600 transition"
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredOrders.map((order) => (
              <div key={order.id} className="bg-white p-3 rounded-lg shadow-md hover:shadow-lg transition">
                <h3 className="text-lg font-semibold text-gray-800">{order.vname}</h3>
                <p className="text-gray-600">Vcode: {order.vcode}</p>
                <p className="text-gray-600">Address: {order.address}</p>
                <p className="text-gray-600">Area: {order.area}</p>
                <p className="text-gray-600">Route1: {order.route1}</p>
                <p className="text-gray-600">Route2: {order.route2}</p>
                <p className="text-gray-600">Start Date: {order.startDate}</p>
                <p className="text-gray-600">Nextdays: {order.nextdays}</p>
                <button
                  onClick={async () => {
                    try {
                      const response = await api.EditFdOrderlistAPI(order.orId);
                      const editData = response?.EditFdOrderlistAPIjs;
                      navigate('/orderform', { state: { editData } });
                    } catch (error) {
                      console.error('Error fetching edit data:', error);
                      alert('Failed to load edit data.');
                    }
                  }}
                  className="mt-2 px-3 py-1 bg-blue-500 text-white text-sm font-semibold rounded hover:bg-blue-600 transition"
                >
                  Edit
                </button>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}